module.exports = {"alarmBox":"Notifications","viewDetails":"View Details","noAlarms":"No notifications received.","answerNoticeLine1":"When you register a reply,","answerNoticeLine2":"a notification will be sent to the inquirer.","answerConfirm":"Do you want to register it?"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/al001.json
// module id = wqHe
// module chunks = 2